<template>
  <base-dialog
    v-model="localValue"
    title="Remove Payment Method"
    :loading="loading"
    :show-footer="true"
    :show-cancel="true"
    :show-confirm="true"
    cancel-label="Cancel"
    confirm-label="Remove"
    confirm-button-class="base-dialog__negative-btn"
    @confirm="$emit('confirm')"
    @cancel="$emit('cancel')"
    persistent
  >
    <div class="remove-payment-dialog__content">
      <p>
        Are you sure you want to remove
        <span class="text-weight-bold">{{ paymentMethod ? `${paymentMethod.type} ending with ${paymentMethod.last4_digit}` : '' }}</span
        >?
      </p>

      <div v-if="paymentMethod && paymentMethod.is_default === 'true'" class="remove-payment-dialog__warning q-mt-sm">
        <q-icon name="warning" size="18px" color="warning" class="q-mr-xs" />
        <span>Note: This is your default payment method.</span>
      </div>
    </div>
  </base-dialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog.vue';

export default {
  name: 'RemovePaymentMethodDialog',
  components: {
    BaseDialog
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    paymentMethod: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.remove-payment-dialog {
  &__content {
    padding: 8px 0;
  }

  &__warning {
    display: flex;
    align-items: center;
    padding: 12px;
    background-color: rgba(var(--warning-rgb), 0.1);
    border-radius: 4px;
    font-size: 14px;
    color: var(--warning-shade);
  }
}
</style>
